import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enLocales from './lang/en';
import ptLocales from './lang/pt';
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)

i18n
  .use(initReactI18next)
  //.use(HttpApi)
  .use(LanguageDetector)
  .init({
    resources: {
      en: { translations: enLocales },
      pt: { translations: ptLocales },
    },
    detection: {
      order: ['localStorage', 'querystring', 'path', 'subdomain', 'htmlTag'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    fallbackLng: 'pt',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    /* backend: {
      loadPath: './assets/lang/{{lng}}/translation.json',
    },*/
  });

export default i18n;
